export function purchaseCallbackFor(marketingEventIdentifier) {
  if (!marketingEventIdentifier) {
    return undefined; // to skip a callback
  }

  const [authenticityTokenElement] = Array.from(
    document.getElementsByName("authenticity_token")
  );

  return (...args) => {
    fetch(`/marketing_events/${marketingEventIdentifier}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        authenticity_token: authenticityTokenElement.value,
      })
    }).then((response) => {
      console.log(response.ok, response.status, args)
    }).catch((error) => {
      console.error(error);
    });

  };
};